import { ChangeEventHandler, FC } from 'react';

import useSWRMutation from 'swr/mutation';

import Checkbox from '@mui/material/Checkbox';

import { tournamentsService } from 'v2/api/tournamentsService';
import { TournamentModel } from 'v2/types/TournamentModel';
import { handleHttpError } from 'v2/utils';

interface TournamentActiveColumnProps {
  tournament: TournamentModel;
  onRevalidate: VoidFunction;
}

export const TournamentActiveColumn: FC<TournamentActiveColumnProps> = ({ tournament, onRevalidate }) => {
  const { trigger } = useSWRMutation(['setActiveTournament', tournament.id], tournamentsService.setActiveTournament, {
    onSuccess: () => {
      onRevalidate();
    },
    onError: handleHttpError,
  });

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    trigger(e.target.checked);
  };

  return <Checkbox color="success" checked={tournament.isActive} onChange={handleChange} />;
};
